import { ReactNode, useEffect, useState } from 'react';

import { subscribeToRenderError } from '../../store/errorReportingStore/devtools/renderErrorEmitter';

/**
 * Invisible component mounted under the outer `Sentry.ErrorBoundary`. When
 * the devtools render-error trigger fires, this component throws during
 * render - exercising the React error boundary path (component stack
 * included) instead of the global error handler.
 */
const RenderErrorTrigger = (): ReactNode => {
  const [message, setMessage] = useState<string | null>(null);

  useEffect((): (() => void) => subscribeToRenderError(setMessage), []);

  if (message !== null) {
    throw new Error(message);
  }

  return null;
};

export default RenderErrorTrigger;
